import { useEffect, useState } from "react";

const WORDS = ["you.", "flat roofs.", "listed homes.", "shaded roofs.", "EV drivers.", "bungalows."];
const TYPE_MS = 75;
const DELETE_MS = 40;
const HOLD_MS = 2400;
const GAP_MS = 280;

type Phase = "typing" | "holding" | "deleting";

export default function RotatingWord() {
  const [index, setIndex] = useState(0);
  const [text, setText] = useState("");
  const [phase, setPhase] = useState<Phase>("typing");
  const [reduceMotion, setReduceMotion] = useState(false);
  const word = WORDS[index];

  useEffect(() => {
    const media = window.matchMedia("(prefers-reduced-motion: reduce)");
    const apply = () => setReduceMotion(media.matches);
    apply();
    media.addEventListener("change", apply);
    return () => media.removeEventListener("change", apply);
  }, []);

  useEffect(() => {
    if (reduceMotion) {
      setText(word);
      const hold = window.setTimeout(() => {
        setIndex((current) => (current + 1) % WORDS.length);
      }, HOLD_MS);
      return () => window.clearTimeout(hold);
    }

    if (phase === "typing") {
      const step = window.setTimeout(() => {
        if (text.length < word.length) setText(word.slice(0, text.length + 1));
        else setPhase("holding");
      }, TYPE_MS);
      return () => window.clearTimeout(step);
    }

    if (phase === "holding") {
      const hold = window.setTimeout(() => setPhase("deleting"), HOLD_MS);
      return () => window.clearTimeout(hold);
    }

    if (text.length > 0) {
      const step = window.setTimeout(() => setText(text.slice(0, -1)), DELETE_MS);
      return () => window.clearTimeout(step);
    }

    const gap = window.setTimeout(() => {
      setIndex((current) => (current + 1) % WORDS.length);
      setPhase("typing");
    }, GAP_MS);
    return () => window.clearTimeout(gap);
  }, [phase, reduceMotion, text, word]);

  return (
    <span
      className="inline font-bold whitespace-nowrap text-ink"
      style={{
        boxShadow: "inset 0 -0.3em 0 #D4FF00",
        borderRight: "0.07em solid #0C0D10",
        paddingRight: "0.08em",
        marginRight: "0.12em",
        animation: phase === "holding" && !reduceMotion ? "powlo-caret 1s step-end infinite" : undefined,
      }}
    >
      {text || "\u00a0"}
    </span>
  );
}
